export const SITE = {
  name: "CYPRUS PRIVÉ",
  claim: "PRIVATE ACCESS TO NORTH CYPRUS",
  logo: "/manus-storage/cyprus-prive-logo-256_bfe0960d.webp",
  images: {
    hero: "/manus-storage/hero-coast-desktop_00fd6cf2.webp",
    heroMobile: "/manus-storage/hero-coast-mobile_e1df3162.webp",
    meeting: "/manus-storage/business-meeting_24563bbf.webp",
    discovery: "/manus-storage/discovery-drive_9180ede0.webp",
    privateAccess: "/manus-storage/private-access_bbb8eea8.webp",
    stay: "/manus-storage/stay-villa_b60d331b.webp",
  },
};

export const NAV_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/leistungen" },
  { label: "Immobilien", href: "/immobilien-nordzypern" },
  { label: "Firmengründung", href: "/firmengruendung-nordzypern" },
  { label: "Banking", href: "/konto-eroeffnen-nordzypern" },
  { label: "Relocation", href: "/auswandern-nordzypern" },
  { label: "Angebote", href: "/pakete" },
  { label: "Stay", href: "/stay" },
  { label: "Investments", href: "/private-investments" },
  { label: "Ratgeber", href: "/ratgeber" },
];

export const LEGAL_NOTE = "CYPRUS PRIVÉ begleitet, koordiniert und organisiert. Rechts-, Steuer- oder regulierte Finanzberatung erfolgt – soweit erforderlich – ausschließlich durch entsprechend qualifizierte Partner. Kontoeröffnungen, Genehmigungen, steuerliche Ergebnisse, Renditen oder Wertentwicklungen werden nicht garantiert.";

export function trackEvent(name: string, data: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("cyprus-prive:event", { detail: { name, ...data } }));
  const analytics = (window as typeof window & { umami?: { track: (event: string, payload?: Record<string, unknown>) => void } }).umami;
  analytics?.track(name, data);
}
